import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularTypeDatasetWithDatabaseAdapts } from './tabular-type.dataset.adapter';
import { AzureSqlDWTableDataset } from 'shell-models-lib';
import { GlobalVariables } from 'app/services/globals';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureSqlDWTableDataset),
    asynchronous: true,
    adapts: {
        ...tabularTypeDatasetWithDatabaseAdapts,
        properties: {
            ...tabularTypeDatasetWithDatabaseAdapts.properties,
            connectionProperties: GlobalVariables.connectionPropertiesForSql ? '*' : undefined
        }
    }
})
export class AzureSqlDWDatasetAdapter extends TabularTypeDatasetAdapter<AzureSqlDWTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: AzureSqlDWTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(AzureSqlDWTableDataset).name,
            undefined,
            undefined,
            undefined,
            undefined,
            __IS_FABRIC_DPE__ || this.context.adapterConfig.convertToFabric ? AzureSqlDWTableDataset.DATABASE : undefined);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: AzureSqlDWTableDataset): Promise<AzureSqlDWTableDataset> {
        return await this._toModelInternal(modelDatasetResource,
            dataset,
            AzureSqlDWTableDataset.MODEL,
            undefined,
            undefined,
            undefined,
            undefined,
            __IS_FABRIC_DPE__ || this.context.adapterConfig.convertToFabric ? AzureSqlDWTableDataset.DATABASE : undefined);
    }
}
